import { render, staticRenderFns } from "./BlockGroupHelpList.vue?vue&type=template&id=5454c086&"
import script from "./BlockGroupHelpList.vue?vue&type=script&lang=js&"
export * from "./BlockGroupHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports